import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Typography } from '@mui/material'
import { useGET_rubricByIdQuery } from 'redux/api/rubricApi'
import _ from 'lodash'
import { usePOST_concernReasonEnableMutation } from 'redux/api/setupApi'

interface IProps {
  id: number
  extraCredit?: number
  rubricGrades?: any
  selectHandler?: any
}


const Rubric: FC<IProps> = ({ id, extraCredit=0, rubricGrades = [], selectHandler = null}) => {
  const { t } = useTranslation()
  const { data: rubric } = useGET_rubricByIdQuery(id.toString())

  const [rows, setRows] = useState([])
  const [stateRubricGrades, setStateRubricGrades] = useState([])


  const calcSelectedPoints = (rubricGrades = [], rubricPoints) => {
    return Math.min(rubricGrades.reduce((acc, rg) => acc + rg.points + (0.25)*rg.extra_credit, 0), rubricPoints)
  }

  const calcSelectedPercentage = (rubricGrades, rubricPoints) => {
    return (rubricPoints > 0 
    ? Math.round((calcSelectedPoints(rubricGrades, rubricPoints)/rubricPoints)*100) 
    : 0)
  }

  useEffect(() => {
    
    if(rubric){
      const criterions = rubric?.rubric_criterions.map(rc => { 
        const selectedGrade = rubricGrades.find(rg => rg.rubric_criterion_id == rc.id)
        return {
          ...rc,
          extra_credit: selectedGrade ? selectedGrade.extra_credit : 0
        }
      }) 
      setRows(criterions)
      setStateRubricGrades(rubricGrades)
    }
    
  }, [rubric])


  return (
    <> { 
        rubric && stateRubricGrades && rows && <div>
          <div className="rubric-slider">
                {rows.map(rc =><div className="rubric-table" key={rc.id}><div className="rubric-row">
                    <div className="rubric-section">{rc.title}</div>
                    {rc.rubric_sections?.map((rs, col) => <div className="rubric-cell" key={rs.id} 
                      style={{ 
                        cursor: selectHandler ? 'pointer' : 'default',
                        background:  stateRubricGrades && stateRubricGrades.map(rg => rg.rubric_section_id).includes(rs.id)
                          ? (col === 0 ? '#ff776e' : '#b3ffc6') 
                          : '', 
                        width: (780/rc.rubric_sections.length)+'px'}}
                    
                      onClick={selectHandler ? ()=>{

                        const newValues = [
                          ...stateRubricGrades.filter(rg => rg.rubric_criterion_id != rc.id),
                          {
                            rubric_criterion_id: rc.id,
                            extra_credit: rc.extra_credit,
                            rubric_section: {
                              id: rs.id,
                              title: rs.title
                            },
                            rubric_section_id: rs.id,
                            points: rs.points
                          }
                        ]

                        setStateRubricGrades(newValues)

                        selectHandler(
                          newValues,
                          calcSelectedPoints(newValues, rubric.points_total),
                          calcSelectedPercentage(newValues, rubric.points_total)
                        )  

                        } : ()=>{}}
                      >
                      
                      <div className="rubric-description" 
                          dangerouslySetInnerHTML={{
                             __html: rs.title ,
                          }} />
                      <div className="rubric-points">{rs.points} {t('common.points')} </div>
                      
                    
                    </div>)}

                    {extraCredit > 0 && <div className="rubric-cell">
                          <div style={{ fontSize: '12px', lineHeight: '14px' }}>{ t('assignments.extra-credit') }:</div>
                          
                          {selectHandler ? 
                          <select onChange={(e) => {

                            const newRows = rows.map(row => {
                              if(rc.id == row.id)return {
                                ...row,
                                extra_credit: e.target.value
                              }
                              else return row
                            })

                            setRows(newRows)
                        
                            const newValues = stateRubricGrades.map(rg => { 
                              if(rg.rubric_criterion_id != rc.id)
                                return rg
                              else
                                return {
                                  ...rg,
                                  extra_credit: e.target.value
                                }
                            })
                          
                            setStateRubricGrades(newValues)

                            selectHandler(
                              newValues,
                              calcSelectedPoints(newValues, rubric.points_total),
                              calcSelectedPercentage(newValues, rubric.points_total)
                            )  

                          }} value={rc.extra_credit}>
                            { _.range(extraCredit+1).map(ec => <option key={ec} value={ec}>{ec}</option>)}
                          </select>
                            : <b>{rc.extra_credit}</b>
                          }
                      </div>}
                </div></div>)}
          </div>
          <div>
            {t('common.points')}: 
              <span style={{ paddingLeft: '5px' }}>{calcSelectedPoints(stateRubricGrades, rubric.points_total)}</span>  / 
              <span style={{ paddingLeft: '5px' }}>{rubric.points_total}</span>
              
          </div>
        </div>
        }
    </>
  )
}

export default Rubric
